<!-- Flexbox layout: fills viewport height and distributes space -->
<div class="flex flex-col h-dvh overflow-hidden">
    <!-- Environment Banner (only shown in non-production) -->
    @if (!isProduction) {
        <div class="w-full py-2 px-4 text-center text-sm font-medium shadow-md z-50"
             [class]="isStaging ? 'bg-warning text-warning-content' : 'bg-info text-info-content'">
            <span class="font-bold">
                {{ isStaging ? '⚠️ STAGING MODE' : '🔧 DEVELOPMENT MODE' }}
            </span>
            <span class="mx-2">|</span>
            <span class="opacity-90">Backend: {{ apiBaseUrl }}</span>
        </div>
    }

    <app-impersonation-banner></app-impersonation-banner>

    @if (keycloakService.currentUser(); as currentUser) {
        <app-header [user]="currentUser"></app-header>
    }

    <!-- Router outlet takes remaining space -->
    <div class="flex-1 bg-base-300 overflow-y-auto min-h-0" style="display: flex; flex-direction: column;">
        <router-outlet></router-outlet>
    </div>
</div>

<app-toast></app-toast>
<app-tour-overlay></app-tour-overlay>
